module.exports = __webpack_public_path__ + "img/delivery03.9ebc4db2.png";